import { SerieDependency } from './serieDependencie.model'

export class HeightReference extends SerieDependency {
  constructor(id: number, name: string) {
    super(id, name)
  }
}
